module.exports = __webpack_public_path__ + "img/no-image.8dc2c281.png";